/**
 * # Cookie Policy Page
 */

/**
 * ## Imports
 */
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { ClientName } from 'client/clientConfig';

import PageFooter from 'common/components/PageFooter/PageFooter';
import PageHeader from 'common/components/PageHeader/PageHeader';
import CopyText from 'common/components/CopyText';
import GetCookieContent from './utils/GetCookieContent';
import { submitMetrics } from '../../lib/submitMetrcis';
import { queryStringToObject } from '../../lib/query';

/**
 * ## Component
 */
const CookiePolicyPage = () => {
    const isSonicClient = ClientName === 'sonic';
    const isAdblockClient = ClientName === 'adblock';
    const location = useLocation();
    const appClassName = `app ${ClientName ? `app--${ClientName}` : ''}`;

    useEffect(() => {
        submitMetrics({
            Category: 'BrowserLandingPage',
            Action: 'view',
            Object: 'webpage',
            ReferalSource: queryStringToObject(location?.search || ''),
        });
    });

    return (
        <div className={appClassName}>
            {(isSonicClient || isAdblockClient) && (
                <PageHeader clientName={ClientName} />
            )}
            <div className="follows-pageheader framed-section framed-section--less-margin-bottom">
                <div className="centerwrapper centerwrapper--very-narrow">
                    <h2 className="headline-main">Cookie Policy</h2>
                    <h3 className="headline-exception-sextary">This Policy was last updated on January 24, 2024</h3>
                </div>
            </div>
            <CopyText clientName={ClientName}>{GetCookieContent()}</CopyText>
            <PageFooter clientName={ClientName} />
        </div>
    );
};

export default CookiePolicyPage;
